import Vue from 'vue';

Vue.filter('title', function(value, replacer = '_') {
    if(!value) return '';
    value = value.toString();

    let arr = value.split(replacer);
    let capitalized_array = [];
    arr.forEach((word) => {
        let capitalized = word.charAt(0).toUpperCase() + word.slice(1);
        capitalized_array.push(capitalized);
    });
    return capitalized_array.join(' ');
});
